import React from 'react';
import Tabs from '../../Components/Navigation/Tabs/Tabs';
import AdminTab from './AdminTab';
import NewsTab from './NewsTab';
import ReviewTab from './ReviewTab';

const ArtificialIntelligencePage: React.FC = () => {
    const tabOptions = [
        {
            title: 'News',
            key: 'News',
            component: <NewsTab />,
            showTab: true,
            testId: 'AiNewsRatingNewsTab',
        },
        {
            title: 'Review',
            key: 'Review',
            component: <ReviewTab />,
            showTab: true,
            testId: 'AiNewsRatingReviewTab',
        },
        {
            title: 'Admin',
            key: 'Admin',
            component: <AdminTab />,
            showTab: true,
            testId: 'AiNewsRatingAdminTab',
        },
    ];

    return <Tabs tabOptions={tabOptions} isModalTab track={{ eventCategory: 'AiNewsRating', eventAction: 'Tab' }} />;
};

export default ArtificialIntelligencePage;
